module.exports = require('./helpers/bundle-url').getBundleURL('cYku6') + "logo.c51670a8.svg";